import getPalaispaConfig from './palaispa/config';
import getCellCareConfig from './cellcare/config';
import getNeologyConfig from './neology/config';
import getTalentConfig from './talent/config';

// 从webpack注入的环境变量中获取配置
// 开发环境：可在 config/dev.env.js 中修改 DEV_BUILD_ENV 来切换环境
// 打包环境：通过 npm run build:sit/pre/prod 自动注入对应环境变量
const nodeEnv = process.env.BUILD_ENV || 'prod';

// 从 process.env 读取配置，兼容开发和生产环境
// 主API服务地址
const baseURL = process.env.VUE_APP_BASE_URL || 'http://localhost:8080';

const proxyPrefix = ''; // 代理前缀在开发环境中由webpack-dev-server处理

// 微信认证服务地址
const AUTH_URL = process.env.VUE_APP_AUTH_URL || '';

// 静态资源访问地址
const VISIT_URL = process.env.VUE_APP_VISIT_URL || '';

// Naturade服务地址
const NATURADE_URL = process.env.VUE_APP_NATURADE_URL || '';

// 通过OpenID获取用户信息的接口地址
const GET_USERINFO_By_OPENID_URL = process.env.VUE_APP_GET_USERINFO_BY_OPENID_URL || '';

// 微信公众号 AppID
const AUTH_APPID = process.env.VUE_APP_AUTH_APPID || '';

// 微信客服 ID
const WECHATKF_ID = process.env.VUE_APP_WECHATKF_ID || '';

// 企业微信相关配置
const CODE_AUTH_AGENT_ID = process.env.VUE_APP_CODE_AUTH_AGENT_ID || '';
const QW_AI_FAQS_AUTH_URL = process.env.VUE_APP_QW_AI_FAQS_AUTH_URL || '';
const QW_BASE_URL = process.env.VUE_APP_QW_BASE_URL || '';

const baseURLMap = {
  beautyfarm: baseURL,
  palaispa: getPalaispaConfig(nodeEnv).baseURL,
  cellcare: getCellCareConfig(nodeEnv).baseURL,
  neology: getNeologyConfig(nodeEnv).baseURL,
  talent: getTalentConfig(nodeEnv).baseURL
};

// brandName = palaispa | beautyfarm
// 若无传入 query.brandName 则默认 beautyfarm
const getBaseUrl = brandName => {
  return baseURLMap[brandName] || baseURLMap.beautyfarm;
};

export {
  baseURL,
  proxyPrefix,
  getBaseUrl,
  nodeEnv,
  AUTH_URL,
  VISIT_URL,
  NATURADE_URL,
  GET_USERINFO_By_OPENID_URL,
  AUTH_APPID,
  WECHATKF_ID,
  CODE_AUTH_AGENT_ID,
  QW_AI_FAQS_AUTH_URL,
  QW_BASE_URL
};



// WEBPACK FOOTER //
// ./src/api/config.js